import alt from 'framework/alt';

class MetricsActions {
  constructor() {
    this.generateActions(
      'postStarted',
      'postSucceeded',
      'postFailed',
      'userAction',
    );
  }
}

export default alt.createActions(MetricsActions);
